import { BaseWidgetRenderer } from './base-widget-renderer';
import { ForgotPasswordWidgetJsonData, WidgetRenderOptions } from '../../models/element-types';
import { TranslateUtils } from '../../utils/translate.utils';

export class ForgotPasswordWidgetRenderer extends BaseWidgetRenderer<ForgotPasswordWidgetJsonData> {
    protected override get defaultData(): ForgotPasswordWidgetJsonData {
        return {
            id: '',
            type: 'forgotpassword',
            content: TranslateUtils.FORGOT_PASSWORD_WIDGET.TEXT
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderContent(widgetJsonData: ForgotPasswordWidgetJsonData, options: WidgetRenderOptions): HTMLElement {
        const content = document.createElement('div');
        content.classList.add('element-content');

        const textElement = document.createElement('div');
        textElement.dataset['inlineInject'] = '';
        textElement.classList.add('ck-content');

        if (widgetJsonData.content) {
            textElement.innerHTML = widgetJsonData.content;
        }

        content.appendChild(textElement);
        return content;
    }
}
